(function(){
    angular
        .module('maApp.core')
        .run(run);

    run.$inject = ['$rootScope', '$routeParams', 'appName', 'appHost', 'Auth', 'UserPrefsRequest', 'ProjectsRequest', 'ngDialog', '$window', '$q', '$log', '$interpolate'];

    function run($rootScope, $routeParams, appName, appHost, Auth, UserPrefsRequest, ProjectsRequest, ngDialog, $window, $q, $log, $interpolate) {

        var rootModel;

        $rootScope.loaded = false;  //controls the loading animation
        $rootScope.appName = appName;
        $rootScope.activeHost = window.location.host;
        $rootScope.halted = false;

        $rootScope.$on("loaded", handleControllerLoaded);   //Listen for the controler to say that it has loaded

        $rootScope.$on('$routeChangeStart', closeAnyOpenDialogs);

        $rootScope.$on("$routeChangeSuccess", loadNewPage);

        document.addEventListener('maApp.exception', handleAppException);

        function main() {
            rootModel = {
                selectedProject: ''
            };
            if ($routeParams.project) {
                rootModel.selectedProject = $routeParams.project;
            }
            //MAIN LOADING CHAIN
            Auth.fetchAuthentication()
                .then(loadAuthentication, referToAuthenticationPage)
                .then(fetchAuthUserGroups)
                .then(setUserPermissions)
                .then(fetchUserPrefsAndProjects)
                .then(setSelectedProjectFromAvailableSources)
                .then(addRootModelToRootScope)
                .then(broadcastAppInitialized);
        }

        function handleAppException(event){
            $rootScope.halted = true;
            if(event.detail.response.status === 401){
                referToAuthenticationPage();
            } else {
                ngDialog.closeAll();
                ngDialog.open({
                    template:'app/view/partials/exceptionDialog.html',
                    data:{
                        errorReport:'Your Comments\n--------\n\n\nError Details\n--------\n' + JSON.stringify(event.detail)
                    },
                    closeByDocument:false
                });
            }

        }

        function fetchAuthUserGroups() {

            return Auth.getUserGroups(rootModel.authentication.userid).then(readSuccess);

            function readSuccess(authUserGroups){
                rootModel.authUserGroups = authUserGroups;
                $log.debug('user auth groups fetched', rootModel.authUserGroups);
            }
        }

        function setUserPermissions(){
            rootModel.authentication.permissions = Auth.getPermissions();
        }

        function fetchUserPrefsAndProjects() {

            // Update selected project
            var userPrefsPromise = UserPrefsRequest.get(rootModel.authentication.userid);

            // List of projects
            var projectsPromise = ProjectsRequest.get();

            //when projects and user prefs finish, take the values they resolved with and add them to the rootModel
            return $q.all([userPrefsPromise, projectsPromise])
                .then(function (allResolvedValues) {
                    rootModel.userPrefs = allResolvedValues[0];
                    rootModel.projects = allResolvedValues[1];

                });
        }

        function getProjectFullName(project) {
            var projects = null;
            if ($rootScope.projects) {    //default value if available
                projects = $rootScope.projects;
            }
            if (arguments.length == 2) {  //allow a second argument to be an array of projects
                projects = arguments[1];
            }
            var projectFullName = '';
            var matchProject = project.toUpperCase();
            for (var i = 0; i < projects.length; i++) {
                if (projects[i].id === matchProject) {
                    projectFullName = projects[i].name;
                    break;
                }
            }
            if (projectFullName.length === 0) {
                throw new Error('Cannout find the full name of the project: ' + project);
            }
            return projectFullName;
        }

        /**
         * setProjectFromAvailableSources
         *
         * Decides to use the project passed in as a url parameter
         * or the project in user preferences
         * @param chainResolveObject
         * @returns {*}
         */
        function setSelectedProjectFromAvailableSources() {
            var hasProject = !!rootModel.selectedProject.length;
            if (!hasProject) {
                rootModel.selectedProject = rootModel.userPrefs['Science_DataEntry_LastProjectSelected'].value;
            }
            if (rootModel.selectedProject.length) {
                rootModel.selectedProjectName = getProjectFullName(rootModel.selectedProject, rootModel.projects);
                rootModel.selectedProjectFullNameEncoded = encodeURIComponent(
                    $interpolate('{{projectId}} > {{name}}')({projectId:rootModel.selectedProject, name:rootModel.selectedProjectName})
                );
            } else {
                rootModel.selectedProjectName = '';
            }
        }

        function broadcastAppInitialized() {
            $rootScope.$broadcast('appinitialized', rootModel, 'appinitialized');
        }

        function addRootModelToRootScope() {
            angular.extend($rootScope, rootModel);
        }

        function referToAuthenticationPage(){
            $window.location = $interpolate('//{{host}}/partners/iwmm/login/?returnUrl={{returnUrl}}')({
                host: appHost,
                returnUrl: encodeURIComponent('/science/managementactions/app/remoteRequest/Auth/authDigest.php')
            });
        }

        function loadAuthentication(authentication){
            rootModel.authentication = authentication;
        }

        function loadNewPage() {
            showLoading();
            main();
        }

        function closeAnyOpenDialogs(){
            ngDialog.closeAll();
        }

        function handleControllerLoaded() {
            showPage();
        }

        function showPage(){
            $rootScope.loaded = true;
        }

        function showLoading(){
            $rootScope.loaded = false;
        }

    }

})();